import styled from 'styled-components';

export const ManageDesktopStyled = styled.section`
  display: none;

  /* @media screen and (min-width: 992px) {
    display: block;
  } */

  padding: 140px 0 0;
  background-color: #e2e6e8;

  .order-1 {
    grid-column: 2/6;
    grid-column: 2/6;
    grid-row: 1/10;

    img {
      margin-top: 40px;
    }
  }

  .order-2 {
    grid-column: 7/13;
    align-items: baseline;
    margin-top: 0;
    grid-row: 1/9;
    box-shadow: rgba(28, 28, 29, 0.1) 0px 25px 65px 0;
  }

  .order-3 {
    grid-column: 1/7;
    grid-row: 11/21;
    align-items: baseline;
    box-shadow: rgba(28, 28, 29, 0.2) 0px 10px 30px 0;
  }

  .order-4 {
    grid-column: 8/13;
    grid-row: 11/21;

    figure {
      margin-bottom: 80px;
    }

    img {
      box-shadow: rgba(28, 28, 29, 0.2) 0px 10px 30px 0;
    }
  }

  .order-5 {
    grid-column: 6/9;
    grid-row: 7/18;
    z-index: 1;
    align-self: baseline;
    box-shadow: rgba(28, 28, 29, 0.4) 0px 30px 60px 0;
    z-index: 500;
  }
`;

export const Article = styled.article`
  grid-column: 1/13;
  grid-template-columns: repeat(12, 1fr);
  margin-bottom: 56px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TextBlock = styled.div`
  grid-column: 1/6;
`;

export const Title = styled.h2`
  margin: 0 0 24px;
  font-size: 32px;
  line-height: 1.5;
  color: #333333;
`;

export const Description = styled.p`
  margin: 0 0 60px;
  font-size: 16px;
  line-height: 1.7;
  color: #727272;
`;

export const Link = styled.a`
  text-decoration: none;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1.7;
  color: #0d96c6;

  &:after {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 10px;
    border-top: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #0d96c6;
  }
`;

export const Figure = styled.figure`
  position: relative;
  display: flex;
  flex-direction: column;
  grid-column: 7/13;
  /* margin-top: 50px; */
  overflow: hidden;

  img {
    max-width: 100%;
  }
`;

export const BottomNote = styled.div`
  display: block;

  h2 {
    margin: 0 0 8px;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 23px;
    text-transform: uppercase;
    color: #eb5424;
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 27px;
    color: #727272;
  }

  &.sdk {
    padding: 80px 0 100px;
    border-top: 1px solid rgba(0, 0, 0, 0.2);

    .inner-wrapper {
      position: relative;
      padding-left: 105px;
      display: block;
      max-width: 795px;
      margin: 0 auto;
    }

    img {
      position: absolute;
      width: 57px;
      height: auto;
      left: 0;
      top: 0;
    }

    h2 {
      display: flex;
      align-items: center;
      margin: 0 0 8px;
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      line-height: 1.5;
    }
  }

  &.dot {
    p {
      position: relative;
      padding-left: 24px;

      &:before {
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        width: 6px;
        height: 6px;
        background-color: #333333;
      }
    }
  }
`;

export const DomainDiagram = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  margin: 0 0 40px;
  background-color: white;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);

  span {
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    color: #727272;
    &.orange {
      color: #eb5424;
    }
  }

  p {
    line-height: 27.2px;
    font-size: 16px;
    color: #727272;
    &.orange {
      color: #eb5424;
    }
  }

  .connector {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-color: #eb5224 transparent transparent transparent;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/ManageDesktop/styled.js